import { render } from "./TecnicosList.vue?vue&type=template&id=fbdf73c6&scoped=true"
import script from "./TecnicosList.vue?vue&type=script&lang=js"
export * from "./TecnicosList.vue?vue&type=script&lang=js"

import "./TecnicosList.vue?vue&type=style&index=0&id=fbdf73c6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbdf73c6"]])

export default __exports__